export default function CStringFunctions() {
  return <h2>C String Functions</h2>;
}
